import { render, staticRenderFns } from "./TextWithTooltip.vue?vue&type=template&id=57d15dba&"
import script from "./TextWithTooltip.vue?vue&type=script&lang=ts&"
export * from "./TextWithTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports